import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=0c8d2fd2"
import script from "./Academy.vue?vue&type=script&lang=js"
export * from "./Academy.vue?vue&type=script&lang=js"
import style0 from "./Academy.vue?vue&type=style&index=0&id=0c8d2fd2&prod&lang=css"
import style1 from "./Academy.vue?vue&type=style&index=1&id=0c8d2fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports